import { useFormFactory } from '@meilleurtaux/form-factory'
import { ModalTransfert } from '@meilleurtaux/form-factory-ds'
import { useState } from 'react'

const TransfertProduit = () => {
  const { transfertActive } = useFormFactory(import.meta.env.VITE_API_URL)

  const [open, setOpen] = useState(transfertActive !== null)

  const handleClose = () => {
    if (transfertActive && transfertActive.redirectMandatory) {
      window.location.href = transfertActive.redirectUrl
    }
    setOpen(false)
  }

  const handleClickCta = () => {
    if (!transfertActive) return
    window.location.href = transfertActive.redirectUrl
  }

  // Resynchronise `open` quand transfertActive change (ajustement pendant le render, pas dans un effet)
  const [previousTransfertActive, setPreviousTransfertActive] = useState(transfertActive)
  if (previousTransfertActive !== transfertActive) {
    setPreviousTransfertActive(transfertActive)
    setOpen(transfertActive !== null)
  }

  return (
    <ModalTransfert
      open={open}
      modalContent={transfertActive?.modalContent ?? ''}
      modalCta={transfertActive?.modalCTA ?? ''}
      modalTitle={transfertActive?.modalTitle ?? ''}
      onClose={handleClose}
      onClickCta={handleClickCta}
    />
  )
}

export default TransfertProduit
